import { toLocale, toPercent, toCurrency } from '../../../helpers/numberHelper';
import { transformObjectValues } from '../../../helpers/utils';
let BRUtils;

const DISPLAY_DATE_FORMAT = 'ddd DD MMM YY';
const ROWS_LABELS = [
    {
        key: 'sellingRate',
        accessor: (row) => row.sellingRate || null,
        label: 'Selling Rate',
    },
    // ROOM ROWS
    {
        key: 'rooms.header',
        accessor: (row) => row.rooms.guaranteed,
        label: 'Rooms - Guaranteed',
    },
    {
        key: 'rooms.guaranteed',
        accessor: (row) => row.rooms.guaranteed - row.rooms.noShow,
        label: 'Guaranteed excl. No-Show',
    },
    {
        key: 'rooms.nonGuaranteed',
        accessor: (row) => row.rooms.nonGuaranteed,
        label: 'Unguaranteed',
    },
    {
        key: 'rooms.tentative',
        accessor: (row) => row.rooms.tentative,
        label: 'Tentative',
    },
    {
        key: 'rooms.noShow',
        accessor: (row) => row.rooms.noShow,
        label: 'No-Show',
    },
    {
        key: 'rooms.cancelled',
        accessor: (row) => row.rooms.cancelled,
        label: 'Cancellations',
    },
    {
        key: 'rooms.ooo',
        accessor: (row) => row.inventory.outOfOrder,
        label: 'Out Of Order',
    },
    {
        key: 'rooms.totalAllStatuses',
        accessor: (row) => row.rooms.guaranteed + row.rooms.nonGuaranteed + row.inventoryBlocks.rooms,
        label: 'Total (all statuses)',
    },
    // REVENUE ROWS
    {
        key: 'revenue.header',
        accessor: (row) => row.revenue.accommodation.guaranteed,
        label: 'Revenue - Guaranteed',
    },
    {
        key: 'revenue.guaranteed',
        accessor: (row) => row.revenue.accommodation.guaranteed - row.revenue.accommodation.noShow,
        label: 'Guaranteed excl. No-Show',
    },
    {
        key: 'revenue.nonGuaranteed',
        accessor: (row) => row.revenue.accommodation.nonGuaranteed,
        label: 'Unguaranteed',
    },
    {
        key: 'revenue.tentative',
        accessor: (row) => row.revenue.accommodation.tentative,
        label: 'Tentative',
    },
    {
        key: 'revenue.noShow',
        accessor: (row) => row.revenue.accommodation.noShow,
        label: 'No-Show',
    },
    {
        key: 'revenue.cancelled',
        accessor: (row) => row.revenue.accommodation.cancelled,
        label: 'Cancellations',
    },
    {
        key: 'revenue.fb',
        accessor: (row) => row.revenue.foodAndBeverage.guaranteed,
        label: 'F&B',
    },
    {
        key: 'revenue.ancillary',
        accessor: (row) => row.revenue.ancillary.guaranteed,
        label: 'Ancillary',
    },
    {
        key: 'revenue.totalAllStatuses',
        accessor: (row) =>
            row.revenue.accommodation.guaranteed +
            row.revenue.accommodation.nonGuaranteed +
            row.inventoryBlocks.revenue,
        label: 'Total (all statuses)',
    },
    {
        key: 'revenue.other',
        accessor: (row) => row.revenue.other.guaranteed,
        label: 'Other',
    },
    // ADR, REVPAR, OCCUPANCY
    {
        key: 'adr',
        accessor: (row) => row.adr,
        label: 'ADR',
    },
    {
        key: 'revPar',
        accessor: (row) => row.revPar,
        label: 'RevPAR',
    },
    {
        key: 'occupancy',
        accessor: (row) => row.occupancy,
        label: 'Occupancy',
    },
    // FORECAST ROWS
    {
        key: 'forecast.revenue',
        accessor: (row) => row.forecast.revenue,
        label: 'Forecast - Revenue',
    },
    {
        key: 'forecast.revenue.variance',
        accessor: (row) => row.forecastVariance.revenue,
        label: 'variance',
    },
    {
        key: 'forecast.rooms',
        accessor: (row) => row.forecast.rooms,
        label: 'Forecast - Rooms',
    },
    {
        key: 'forecast.rooms.variance',
        accessor: (row) => row.forecastVariance.rooms,
        label: 'variance',
    },
    {
        key: 'forecast.occupancy',
        accessor: (row) => row.forecast.occupancy,
        label: 'Forecast - Occupancy',
    },
    {
        key: 'forecast.occupancy.variance',
        accessor: (row) => row.forecastVariance.occupancy,
        label: 'variance',
    },
    {
        key: 'forecast.adr',
        accessor: (row) => row.forecast.adr,
        label: 'Forecast - ADR',
    },
    {
        key: 'forecast.adr.variance',
        accessor: (row) => row.forecastVariance.adr,
        label: 'variance',
    },
    {
        key: 'forecast.revPar',
        accessor: (row) => row.forecast.revPar,
        label: 'Forecast - RevPAR',
    },
    {
        key: 'forecast.revPar.variance',
        accessor: (row) => row.forecastVariance.revPar,
        label: 'variance',
    },
    // BUDGET ROWS
    {
        key: 'budget.revenue',
        accessor: (row) => row.budget.revenue.accommodation,
        label: 'Budget - Revenue',
    },
    {
        key: 'budget.revenue.variance',
        accessor: (row) => row.budgetVariance.revenue.accommodation,
        label: 'variance',
    },
    {
        key: 'budget.rooms',
        accessor: (row) => row.budget.rooms,
        label: 'Budget - Rooms',
    },
    {
        key: 'budget.rooms.variance',
        accessor: (row) => row.budgetVariance.rooms,
        label: 'variance',
    },
    {
        key: 'budget.occupancy',
        accessor: (row) => row.budget.occupancy,
        label: 'Budget - Occupancy',
    },
    {
        key: 'budget.occupancy.variance',
        accessor: (row) => row.budgetVariance.occupancy,
        label: 'variance',
    },
    {
        key: 'budget.adr',
        accessor: (row) => row.budget.adr,
        label: 'Budget - ADR',
    },
    {
        key: 'budget.adr.variance',
        accessor: (row) => row.budgetVariance.adr,
        label: 'variance',
    },
    {
        key: 'budget.revPar',
        accessor: (row) => row.budget.revPar,
        label: 'Budget - RevPAR',
    },
    {
        key: 'budget.revPar.variance',
        accessor: (row) => row.budgetVariance.revPar,
        label: 'variance',
    },
    {
        key: 'statistics.revenue.accommodation',
        accessor: (row) => row.statistics.revenue.accommodation,
        label: 'PMS - Balancing Revenue',
    },
    // INVENTORY BLOCKS
    {
        key: 'invBlock.revenue',
        accessor: (row) => row.inventoryBlocks.revenue,
        label: 'Group blocks',
    },
    {
        key: 'invBlock.rooms',
        accessor: (row) => row.inventoryBlocks.rooms,
        label: 'Group blocks',
    },
];
// Order the rows will be displayed in in the grid/CSV file
const ROWS_ORDER = [
    'sellingRate',
    // Room rows
    'rooms.header',
    'rooms.guaranteed',
    'rooms.nonGuaranteed',
    'rooms.tentative',
    'invBlock.rooms',
    'rooms.totalAllStatuses',
    'rooms.cancelled',
    'rooms.noShow',
    'rooms.ooo',
    // Revenue rows
    'revenue.header',
    'revenue.guaranteed',
    'revenue.nonGuaranteed',
    'revenue.tentative',
    'invBlock.revenue',
    'revenue.fb',
    'revenue.ancillary',
    'revenue.totalAllStatuses',
    'revenue.other',
    'revenue.cancelled',
    'revenue.noShow',
    'statistics.revenue.accommodation',
    // Revenue figures
    'adr',
    'revPar',
    'occupancy',
    // Forecast
    'forecast.revenue',
    'forecast.revenue.variance',
    'forecast.rooms',
    'forecast.rooms.variance',
    'forecast.occupancy',
    'forecast.occupancy.variance',
    'forecast.adr',
    'forecast.adr.variance',
    'forecast.revPar',
    'forecast.revPar.variance',
    // Budget
    'budget.revenue',
    'budget.revenue.variance',
    'budget.rooms',
    'budget.rooms.variance',
    'budget.occupancy',
    'budget.occupancy.variance',
    'budget.adr',
    'budget.adr.variance',
    'budget.revPar',
    'budget.revPar.variance',
];
// Whitelist to prevent some rows from being removed when all values are empty
const EMPTY_ROWS_WHITELIST =
    process.env.NODE_ENV === 'production' ? [] : Object.values(ROWS_LABELS).map((row) => row.key);

// Maps a typeOfData (see #getTypeOfDataFor) to a transformer to apply to display the value in the grid
const varianceNumberFormatter = (value) => {
    if (value === null) return 'N/A';
    const displayValue = toLocale(Math.abs(value));
    return value < 0 ? `(${displayValue})` : displayValue;
};

const variancePercentFormatter = (value) => {
    if (value === null) return 'N/A';
    const displayValue = toPercent(Math.abs(value));
    return value < 0 ? `(${displayValue})` : displayValue;
};

const GRID_CELL_TRANSFORMERS = {
    preciseCurrency: (value, currency) => toCurrency(value / 100, currency, 2),
    currency: (value, currency) => toCurrency(value / 100, currency),
    optionalPreciseCurrency: (value, currency) => (value === null ? '' : toCurrency(value / 100, currency, 2)),
    number: (value) => (value === null ? 'N/A' : toLocale(value)),
    percentage: (value) => toPercent(value),
    budgetCurrency: (value, currency) => (value === null ? 'N/A' : toCurrency(value / 100, currency, 2)),
    budgetNumber: (value) => (value === null ? 'N/A' : toLocale(value)),
    budgetPercentage: (value) => (value === null ? 'N/A' : toPercent(value)),
    varianceCurrency: (value, currency) => {
        if (value === null) return 'N/A';
        const displayValue = toCurrency(Math.abs(value / 100), currency, 2);
        return value < 0 ? `(${displayValue})` : displayValue;
    },
    varianceNumber: varianceNumberFormatter,
    variancePercentage: variancePercentFormatter,
    cancelledRooms: (value) => `(${toLocale(value)})`,
    cancelledRevenue: (value, currency) => `(${toCurrency(value / 100, currency, 2)})`,
};
// Maps a typeOfData (see #getTypeOfDataFor) to a transformer to apply to display the value in the exported file
const EXPORTED_FILE_TRANSFORMERS = {
    // do not use toCurrency, we do not export the currency sign
    preciseCurrency: (value) => toLocale(value / 100, 2),
    currency: (value) => toLocale(value / 100),
    optionalPreciseCurrency: (value) => (value === null ? '' : toLocale(value / 100, 2)),
    number: (value) => (value === null ? 'N/A' : toLocale(value)),
    percentage: (value) => toPercent(value),
    budgetCurrency: (value) => (value === null ? 'N/A' : toLocale(value / 100, 2)),
    budgetNumber: (value) => (value === null ? 'N/A' : toLocale(value)),
    budgetPercentage: (value) => (value === null ? 'N/A' : toPercent(value)),
    varianceCurrency: (value) => {
        if (value === null) return 'N/A';
        const displayValue = toLocale(Math.abs(value / 100), 2);
        return value < 0 ? `(${displayValue})` : displayValue;
    },
    varianceNumber: varianceNumberFormatter,
    variancePercentage: variancePercentFormatter,
    cancelledRooms: (value) => `(${toLocale(value)})`,
    cancelledRevenue: (value) => `(${toLocale(value / 100, 2)})`,
};

/**
 * Return the type of data given its key
 * @param  {string} key
 * @return {object} an object with the datatype for the columns (columnDataType) & total (totalDataType).
 *                  Type is one of:
 *                  - number
 *                  - preciseCurrency
 *                  - optionalPreciseCurrency
 *                  - currency
 *                  - percentage
 *                  - budgetCurrency
 *                  - budgetNumber
 *                  - budgetPercentage
 *                  - varianceCurrency
 *                  - varianceNumber
 *                  - variancePercentage
 *                  - cancelledRooms
 *                  - cancelledRevenue
 */
export const getTypeOfDataFor = (key) => {
    switch (key) {
        case 'rooms.header':
        case 'rooms.guaranteed':
        case 'rooms.nonGuaranteed':
        case 'rooms.tentative':
        case 'rooms.noShow':
        case 'rooms.ooo':
        case 'rooms.totalAllStatuses':
        case 'invBlock.rooms':
            return {
                columnDataType: 'number',
                totalDataType: 'number',
            };
        case 'rooms.cancelled':
            return {
                columnDataType: 'cancelledRooms',
                totalDataType: 'cancelledRooms',
            };
        case 'budget.rooms':
        case 'forecast.rooms':
            return {
                columnDataType: 'budgetNumber',
                totalDataType: 'budgetNumber',
            };
        case 'revenue.header':
        case 'revenue.guaranteed':
        case 'revenue.nonGuaranteed':
        case 'revenue.tentative':
        case 'revenue.noShow':
        case 'revenue.fb':
        case 'revenue.ancillary':
        case 'revenue.other':
        case 'revenue.totalAllStatuses':
        case 'adr':
        case 'revPar':
            return {
                columnDataType: 'preciseCurrency',
                totalDataType: 'preciseCurrency',
            };
        case 'sellingRate':
            return {
                columnDataType: 'optionalPreciseCurrency',
                totalDataType: 'optionalPreciseCurrency',
            };
        case 'revenue.cancelled':
            return {
                columnDataType: 'cancelledRevenue',
                totalDataType: 'cancelledRevenue',
            };
        case 'budget.revenue':
        case 'budget.adr':
        case 'budget.revPar':
        case 'statistics.revenue.accommodation':
        case 'invBlock.revenue':
        case 'forecast.revenue':
        case 'forecast.adr':
        case 'forecast.revPar':
            return {
                columnDataType: 'budgetCurrency',
                totalDataType: 'budgetCurrency',
            };
        case 'budget.revenue.variance':
        case 'budget.adr.variance':
        case 'budget.revPar.variance':
        case 'forecast.revenue.variance':
        case 'forecast.adr.variance':
        case 'forecast.revPar.variance':
            return {
                columnDataType: 'varianceCurrency',
                totalDataType: 'varianceCurrency',
            };
        case 'budget.occupancy':
        case 'forecast.occupancy':
            return {
                columnDataType: 'budgetPercentage',
                totalDataType: 'budgetPercentage',
            };
        case 'budget.occupancy.variance':
        case 'forecast.occupancy.variance':
            return {
                columnDataType: 'variancePercentage',
                totalDataType: 'variancePercentage',
            };
        case 'budget.rooms.variance':
        case 'forecast.rooms.variance':
            return {
                columnDataType: 'varianceNumber',
                totalDataType: 'varianceNumber',
            };
        case 'occupancy':
            return {
                columnDataType: 'percentage',
                totalDataType: 'percentage',
            };
        default:
            return {
                columnDataType: 'number',
                totalDataType: 'number',
            };
    }
};

/**
 * Swap the data array so that the rows (dates) become the columns
 * Also fill hasData var to determine if a row contains values (for quick cleanup)
 * @param  {object}   data           - the data to format
 * @param  {object[]} data.rows      - the rows
 * @param  {object}   data.totalRow  - the totals row
 * @param  {object[]} rowsDefinition - list of rows to extract from the data, containing a key,
 *                                    an extractor (accessor) & the label to be displayed
 * @param  {string}   displayDateFormat - format to display the date in
 * @return {object[]} the data with the dates as columns
 */
const swapColumnAndRows = (data, rowsDefinition, displayDateFormat) => {
    const initialRowsObject = rowsDefinition.reduce(
        (accu, f) => ({
            ...accu,
            [f.key]: {
                key: f.key,
                label: f.label,
                hasData: false,
            },
        }),
        {},
    );
    /* eslint-disable no-param-reassign */
    const formattedRows = data.rows.reduce((accu, row) => {
        const dateKey = row.date.format(displayDateFormat);
        rowsDefinition.forEach(({ key, accessor }) => {
            const value = accessor(row);
            accu[key][dateKey] = value;
            if (value !== 0 && value !== null) accu[key].hasData = true;
        });
        return accu;
    }, initialRowsObject);
    /* eslint-enable no-param-reassign */

    rowsDefinition.forEach(({ key, accessor }) => {
        const total = accessor(data.totalRow);
        formattedRows[key].total = total;
    });
    return formattedRows;
};

/**
 * Remove rows where the hasData boolean is false, unless the keys is whitelisted
 * @param  {object}   data      - the data to clean
 * @param  {string[]} whitelist - list of keys to not remove, even if empty
 * @return {object} the object with the empty rows removed
 */
const removeEmptyRows = (data, whitelist) =>
    Object.keys(data)
        .filter((key) => whitelist.includes(key) || data[key].hasData)
        .reduce(
            (obj, key) => ({
                ...obj,
                [key]: data[key],
            }),
            {},
        );

/**
 * Remove rows that should be excluded
 * @param  {object}   data      - the data to clean
 * @param  {string[]} excludedRows - list of keys to not remove, even if empty
 * @return {object} the object with the excluded rows removed
 */
const removeExcludedRows = (data, excludedRows) =>
    Object.keys(data)
        .filter((key) => !excludedRows.includes(key))
        .reduce(
            (obj, key) => ({
                ...obj,
                [key]: data[key],
            }),
            {},
        );

/**
 * Reorder an object's keys given an order
 * Keys in #order that aren't in the data are ignored
 * Extra keys that are not in the #order variable are copied at the end, in the same order
 * @param  {object}   data  - object to re-order
 * @param  {string[]} order - list of properties, in order
 * @return {object} re-ordered object
 */
const reorderKeys = (data, order) => ({
    ...order
        .filter((key) => data[key])
        .reduce(
            (obj, key) => ({
                ...obj,
                [key]: data[key],
            }),
            {},
        ),
    ...data,
});

/**
 * Transform the BusinessReview data to be displayed in the grid, by extracting wanted properties,
 * swapping columns & rows, reordering data & removing empty rows
 * @param  {object}   data          - The processed data
 * @param  {object[]} data.rows     - Rows for each date
 * @param  {object}   data.totalRow - Row containing totals
 * @param  {string[]}  excludedRows
 * @return {object} an object with 1 property per row to be displayed
 */
export const transformDataForGrid = (data, excludedRows) => {
    if (excludedRows.includes('invBlock.revenue')) {
        ROWS_LABELS.find(({ key }) => key === 'rooms.totalAllStatuses').accessor = (row) =>
            row.rooms.guaranteed + row.rooms.nonGuaranteed;
        ROWS_LABELS.find(({ key }) => key === 'revenue.totalAllStatuses').accessor = (row) =>
            row.revenue.accommodation.guaranteed + row.revenue.accommodation.nonGuaranteed;
    } else {
        ROWS_LABELS.find(({ key }) => key === 'rooms.totalAllStatuses').accessor = (row) =>
            row.rooms.guaranteed + row.rooms.nonGuaranteed + row.inventoryBlocks.rooms;
        ROWS_LABELS.find(({ key }) => key === 'revenue.totalAllStatuses').accessor = (row) =>
            row.revenue.accommodation.guaranteed +
            row.revenue.accommodation.nonGuaranteed +
            row.inventoryBlocks.revenue;
    }
    const swappedData = BRUtils.swapColumnAndRows(data, ROWS_LABELS, DISPLAY_DATE_FORMAT);
    const cleanData = BRUtils.removeEmptyRows(swappedData, EMPTY_ROWS_WHITELIST);
    const dataWithoutExcludedRows = BRUtils.removeExcludedRows(cleanData, excludedRows);
    const reorderedData = BRUtils.reorderKeys(dataWithoutExcludedRows, ROWS_ORDER);
    return reorderedData;
};

/**
 * Return the grouping for a row
 * @param  {object}   grouping
 * @param  {string}   grouping.parentKey    - parent key to group under
 * @param  {string[]} grouping.childrenKeys - list of the keys of children to group
 * @param  {object}   data                  - data, containing the children to extract
 * @param  {object}   visibilityState       - current state of the grouped rows, describing if they are expanded or collapsed
 * @param  {callback} onClickHandler        - the event handler to expand/collapse a row
 * @return {object} the object with the expanded|cellClicked & children properties set
 */
const getGroupingFor = ({ parentKey, childrenKeys }, data, visibilityState, onClickHandler) => {
    const children = Object.values(data)
        .filter((row) => childrenKeys.includes(row.key))
        .map((row) => ({ ...row, isSubRow: true }));
    return {
        expanded: visibilityState[parentKey] || false,
        cellClicked: onClickHandler,
        children,
    };
};

/**
 * Group rows under other given a grouping model
 * @param  {object}   data          - the data to group
 * @param  {object[]} rowsGrouping  - the row grouping, i.e. parent/children keys
 * @param  {object} visibilityState - current state, i.e. which rows are expanded/collapsed
 * @param  {callback} handler       - click event handler to collapse/expand rows
 * @return {object} the data with rows groupped
 */
export const groupRows = (data, rowsGrouping, visibilityState, handler) => {
    const childrenKeys = rowsGrouping.reduce((keys, grouping) => keys.concat(grouping.childrenKeys), []);
    return Object.values(data)
        .filter((row) => !childrenKeys.includes(row.key))
        .reduce((accu, row) => {
            const grouping = rowsGrouping.find((group) => group.parentKey === row.key);
            return {
                ...accu,
                [row.key]: {
                    ...row,
                    ...(grouping && BRUtils.getGroupingFor(grouping, data, visibilityState, handler)),
                },
            };
        }, {});
};

/**
 * Extract non-displayed properties from object & format the other ones
 * @param  {object}   object       - object to transform
 * @param  {object[]} transformers - transformers to apply per type of data. Takes 2 parameters each: the value & the currency
 * @param  {string} currency       - The currency for the revenue figures
 * @return {object} the object with all values transformed
 */
const formatBRObject = (object, transformers, currency) => {
    const { label, key, hasData, total, ...valuesToTransform } = object;
    const { columnDataType, totalDataType } = BRUtils.getTypeOfDataFor(key);
    return {
        ...transformObjectValues(valuesToTransform, transformers[columnDataType], [currency]),
        total: transformers[totalDataType](total, currency),
    };
};

/**
 * Format values of object properties for display
 * @param  {object} data - data to format
 * @param  {string} currency - The currency for the revenue figures
 * @return {object} data with values transformed
 */
export const formatData = (data, currency) =>
    Object.values(data).reduce(
        (objectAccu, row) => ({
            ...objectAccu,
            [row.key]: {
                ...row,
                ...BRUtils.formatBRObject(row, GRID_CELL_TRANSFORMERS, currency),
            },
        }),
        {},
    );

/**
 * Cleanup data by removing unwanted properties & format values for CSV export
 * @param  {object} data            - The processed data, as returned by #transformDataForGrid
 * @param  {string} currency        - The currency for the revenue figures
 * @param  {string[]} rowsBlacklist - list of rows (keys) that should not be shown in the exported file
 * @return {object} the data, cleaned up & transformed
 */
export const transformDataForCSV = (data, currency, rowsBlacklist) =>
    Object.values(data)
        .filter((row) => !rowsBlacklist.includes(row.key))
        .reduce(
            (objectAccu, row) => ({
                ...objectAccu,
                [row.key]: {
                    date: row.label,
                    ...BRUtils.formatBRObject(row, EXPORTED_FILE_TRANSFORMERS, currency),
                },
            }),
            {},
        );

/**
 * Cleanup data by removing unwanted properties & format values for CSV export
 * @param  {object} data            - The processed data, as returned by #transformDataForGrid
 * @param  {string} currency        - The currency for the revenue figures
 * @param  {string[]} rowsBlacklist - list of rows (keys) that should not be shown in the exported file
 * @return {object} the data, cleaned up & transformed
 */
export const addTreeStructure = (data) => {
    const flattened = [];
    data?.forEach((d) => {
        flattened.push({
            ...d,
            path: d.key,
        });
        d.children?.forEach((c) => {
            flattened.push({
                ...c,
                path: `${d.key}/${c.key}`,
            });
        });
    });
    return flattened;
};

export default BRUtils = {
    getTypeOfDataFor,
    swapColumnAndRows,
    removeEmptyRows,
    removeExcludedRows,
    reorderKeys,
    getGroupingFor,
    formatBRObject,
    transformDataForGrid,
    transformDataForCSV,
    formatData,
    groupRows,
};
export { ROWS_LABELS, GRID_CELL_TRANSFORMERS, EXPORTED_FILE_TRANSFORMERS };
